import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Fade } from "react-reveal";
import Skeleton from "react-loading-skeleton";

const boxesdata = [
  {
    boxicon: "/images/icon1.png",
    boxheading: "Truested Security",
    boxdescription:
      "The security level of the Savy security platform is maintained and controlled properly and consistently.",
  },

  {
    boxicon: "/images/icon2.png",
    boxheading: "Simple buy & sell options",
    boxdescription:
      "Savy is always the newest and best platform in every trading platform that exists.",
  },

  {
    boxicon: "/images/icon3.png",
    boxheading: "Support System",
    boxdescription:
      "For those of you who are the first to use Morry, we also provide a step-by-step tutorial to help you",
  },

  {
    boxicon: "/images/icon4.png",
    boxheading: "Connect Bank Account",
    boxdescription:
      "You can top up or make transactions to all banks around the world",
  },
];

const Confident = ({ settingInfo, loading }) => {
  return (
    <>
      <section className="confident_section">
        <div className="gradient_boxone"></div>
        <div className="gradient_boxtwo"></div>

        <Container>
          <div className="heading_Common_toall position-relative">
            <h2 className="heading_common">{settingInfo?.heading1}</h2>

            <div className="arrow_here">
              <img src="/images/bottomarrow.png" alt="" className="img-fluid" />
            </div>
          </div>

          <div className="confidentily_boxes">
            <Row>
              {settingInfo?.counts?.length > 0 &&
                settingInfo?.counts?.map((items, idx) => {
                  return (
                    <Col lg={3} md={6} sm={12}>
                      {loading ? (
                        <Skeleton width={"80%"} height={26} />
                      ) : (
                        <div className="boxes_common text-start">
                          <div className="icon-div">
                            <img
                              src={items.logo}
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                          <div className="boxe_Content mt-4">
                            <h4>{items.heading}</h4>
                            <p>{items.description}</p>
                          </div>
                        </div>
                      )}
                    </Col>
                  );
                })}
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Confident;
